import { BookingReducerProps } from '@core/features';
import { useBookingState } from '..';
import { BookingSetting } from '@core/models';

export const useOptimisticBookingState = (): BookingReducerProps & {
  bookingSetting: BookingSetting;
} => {
  const bookingState = useBookingState();
  return bookingState as any;
};
